//esm-shim-webpack-plugin-imports
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== "undefined" ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "../editor-platform-sdk-types/dist/esm/common.js":
/*!*******************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/common.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AddElementsPanelBannerIcons: () => (/* binding */ AddElementsPanelBannerIcons),
/* harmony export */   DeviceType: () => (/* binding */ DeviceType),
/* harmony export */   LinkTypes: () => (/* binding */ LinkTypes),
/* harmony export */   TPAComponentType: () => (/* binding */ TPAComponentType),
/* harmony export */   WidgetInstallationType: () => (/* binding */ WidgetInstallationType)
/* harmony export */ });
var LinkTypes;
(function (LinkTypes) {
  LinkTypes["NoLink"] = "NoLink";
  LinkTypes["PageLink"] = "PageLink";
  LinkTypes["AnchorLink"] = "AnchorLink";
  LinkTypes["ExternalLink"] = "ExternalLink";
  LinkTypes["DocumentLink"] = "DocumentLink";
  LinkTypes["PhoneLink"] = "PhoneLink";
  LinkTypes["EmailLink"] = "EmailLink";
  LinkTypes["LoginToWixLink"] = "LoginToWixLink";
  LinkTypes["DynamicPageLink"] = "DynamicPageLink";
  LinkTypes["EdgeAnchorLink"] = "EdgeAnchorLinks";
  LinkTypes["PopupLink"] = "PopupLink";
  LinkTypes["FormSubmitButtonLink"] = "FormSubmitButtonLink";
})(LinkTypes || (LinkTypes = {}));
var DeviceType;
(function (DeviceType) {
  DeviceType["Desktop"] = "desktop";
  DeviceType["Mobile"] = "mobile";
})(DeviceType || (DeviceType = {}));
var TPAComponentType;
(function (TPAComponentType) {
  TPAComponentType["Page"] = "PAGE";
  TPAComponentType["Widget"] = "WIDGET";
})(TPAComponentType || (TPAComponentType = {}));
var WidgetInstallationType;
(function (WidgetInstallationType) {
  WidgetInstallationType["Open"] = "open";
  WidgetInstallationType["Closed"] = "closed";
})(WidgetInstallationType || (WidgetInstallationType = {}));
var AddElementsPanelBannerIcons;
(function (AddElementsPanelBannerIcons) {
  AddElementsPanelBannerIcons["AllBreakpoints"] = "all-breakpoints";
})(AddElementsPanelBannerIcons || (AddElementsPanelBannerIcons = {}));
const AppController = 'platform.components.AppController';
const AppWidget = 'platform.components.AppWidget';
const Page = 'mobile.core.components.Page';

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/appEditorApi.js":
/*!*************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/appEditorApi.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/appReflow.js":
/*!**********************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/appReflow.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/consentPolicy.js":
/*!**************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/consentPolicy.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/index.js":
/*!******************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/index.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EditorSubType: () => (/* reexport safe */ _origin__WEBPACK_IMPORTED_MODULE_5__.EditorSubType),
/* harmony export */   EditorType: () => (/* reexport safe */ _origin__WEBPACK_IMPORTED_MODULE_5__.EditorType),
/* harmony export */   InstallInitiator: () => (/* reexport safe */ _origin__WEBPACK_IMPORTED_MODULE_5__.InstallInitiator),
/* harmony export */   InstallationOriginType: () => (/* reexport safe */ _origin__WEBPACK_IMPORTED_MODULE_5__.InstallationOriginType),
/* harmony export */   MediaType: () => (/* reexport safe */ _media__WEBPACK_IMPORTED_MODULE_2__.MediaType),
/* harmony export */   NotificationPresetTypes: () => (/* reexport safe */ _notifications__WEBPACK_IMPORTED_MODULE_4__.NotificationPresetTypes),
/* harmony export */   NotificationType: () => (/* reexport safe */ _notifications__WEBPACK_IMPORTED_MODULE_4__.NotificationType),
/* harmony export */   PagesPanelTabType: () => (/* reexport safe */ _panels__WEBPACK_IMPORTED_MODULE_7__.PagesPanelTabType),
/* harmony export */   PanelResolveType: () => (/* reexport safe */ _panels__WEBPACK_IMPORTED_MODULE_7__.PanelResolveType),
/* harmony export */   PanelType: () => (/* reexport safe */ _panels__WEBPACK_IMPORTED_MODULE_7__.PanelType),
/* harmony export */   PremiumIntent: () => (/* reexport safe */ _premiumIntent__WEBPACK_IMPORTED_MODULE_8__.PremiumIntent),
/* harmony export */   customizeActions: () => (/* reexport safe */ _panels__WEBPACK_IMPORTED_MODULE_7__.customizeActions)
/* harmony export */ });
/* harmony import */ var _appEditorApi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./appEditorApi */ "../editor-platform-sdk-types/dist/esm/definitions/appEditorApi.js");
/* harmony import */ var _consentPolicy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./consentPolicy */ "../editor-platform-sdk-types/dist/esm/definitions/consentPolicy.js");
/* harmony import */ var _media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./media */ "../editor-platform-sdk-types/dist/esm/definitions/media.js");
/* harmony import */ var _monitoring__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./monitoring */ "../editor-platform-sdk-types/dist/esm/definitions/monitoring.js");
/* harmony import */ var _notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./notifications */ "../editor-platform-sdk-types/dist/esm/definitions/notifications.js");
/* harmony import */ var _origin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./origin */ "../editor-platform-sdk-types/dist/esm/definitions/origin.js");
/* harmony import */ var _pageDefinition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./pageDefinition */ "../editor-platform-sdk-types/dist/esm/definitions/pageDefinition.js");
/* harmony import */ var _panels__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./panels */ "../editor-platform-sdk-types/dist/esm/definitions/panels.js");
/* harmony import */ var _premiumIntent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./premiumIntent */ "../editor-platform-sdk-types/dist/esm/definitions/premiumIntent.js");
/* harmony import */ var _responsiveLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./responsiveLayout */ "../editor-platform-sdk-types/dist/esm/definitions/responsiveLayout.js");
/* harmony import */ var _info__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./info */ "../editor-platform-sdk-types/dist/esm/definitions/info.js");
/* harmony import */ var _appReflow__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./appReflow */ "../editor-platform-sdk-types/dist/esm/definitions/appReflow.js");













/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/info.js":
/*!*****************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/info.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/media.js":
/*!******************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/media.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MediaType: () => (/* binding */ MediaType)
/* harmony export */ });
/**
 * @doc Editor
 */
var MediaType;
(function (MediaType) {
  MediaType["Image"] = "IMAGE";
  MediaType["Video"] = "VIDEO";
  MediaType["Document"] = "DOCUMENT";
})(MediaType || (MediaType = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/monitoring.js":
/*!***********************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/monitoring.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/notifications.js":
/*!**************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/notifications.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NotificationPresetTypes: () => (/* binding */ NotificationPresetTypes),
/* harmony export */   NotificationType: () => (/* binding */ NotificationType)
/* harmony export */ });
/**
 * @doc Editor
 */
var NotificationType;
(function (NotificationType) {
  NotificationType["Success"] = "success";
  NotificationType["Error"] = "error";
  NotificationType["Warning"] = "warning";
  NotificationType["Info"] = "info";
})(NotificationType || (NotificationType = {}));
var NotificationPresetTypes;
(function (NotificationPresetTypes) {
  NotificationPresetTypes["REPEATER_EDITOR_MAX_ITEMS"] = "repeaterMaxItemsEditorLimitation";
})(NotificationPresetTypes || (NotificationPresetTypes = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/origin.js":
/*!*******************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/origin.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EditorSubType: () => (/* binding */ EditorSubType),
/* harmony export */   EditorType: () => (/* binding */ EditorType),
/* harmony export */   InstallInitiator: () => (/* binding */ InstallInitiator),
/* harmony export */   InstallationOriginType: () => (/* binding */ InstallationOriginType)
/* harmony export */ });
var EditorType;
(function (EditorType) {
  EditorType["Classic"] = "CLASSIC";
  EditorType["Responsive"] = "RESPONSIVE";
  EditorType["ADI"] = "ADI";
  EditorType["ADI_MA"] = "ADI_MA";
  EditorType["ADI_TEMPLATE"] = "ADI_TEMPLATE";
  EditorType["Blocks"] = "blocks";
})(EditorType || (EditorType = {}));
var EditorSubType;
(function (EditorSubType) {
  EditorSubType["EditorX"] = "EDITOR_X";
  EditorSubType["Studio"] = "STUDIO";
})(EditorSubType || (EditorSubType = {}));
var InstallInitiator;
(function (InstallInitiator) {
  /**
   * Application was installed by a user action in the Editor.
   */
  InstallInitiator["Editor"] = "EDITOR";
  /**
   * Application was installed by another Application.
   */
  InstallInitiator["App"] = "APP";
  /**
   * Application was installed by dependency services defined on app market.
   */
  InstallInitiator["Dependency_Service"] = "Dependency_Service";
})(InstallInitiator || (InstallInitiator = {}));
var InstallationOriginType;
(function (InstallationOriginType) {
  /**
   * Application was installed from the App Market.
   */
  InstallationOriginType["AppMarket"] = "APP_MARKET";
  /**
   * Application was installed from the Add Panel.
   */
  InstallationOriginType["AddPanel"] = "ADD_PANEL";
  /**
   * Application was installed from the Application Panel.
   */
  InstallationOriginType["AppPanel"] = "APP_PANEL";
  /**
   * Application was installed from the Pages Panel Settings Panel.
   */
  InstallationOriginType["PageSettingsPanel"] = "PAGE_SETTINGS_PANEL";
  /**
   * Application was installed by PAAS (Preset as a service).
   */
  InstallationOriginType["PresetService"] = "PRESET_SERVICE";
  /**
   * Application was installed by Site Creation - Widgets flow.
   */
  InstallationOriginType["SITE_CREATION"] = "SITE_CREATION";
  /**
   * Application was installed by AI Site Generation.
   */
  InstallationOriginType["SITE_GENERATION"] = "SITE_GENERATION";
  /**
   * Application was installed by Site Creation - Silent flow.
   */
  InstallationOriginType["SILENT_INSTALL_SITE_CREATION"] = "SILENT_INSTALL_SITE_CREATION";
  /**
   * Application was installed by Silent Installation service.
   */
  InstallationOriginType["SILENT_INSTALL"] = "SILENT_INSTALL";
  /**
   * Application was installed by Intent Installation service.
   */
  InstallationOriginType["INTENT_INSTALL"] = "INTENT_INSTALL";
  /**
   * Application was installed from the Add Section Panel.
   */
  InstallationOriginType["ADD_SECTION_PANEL"] = "ADD_SECTION_PANEL";
  /**
   * Application was installed from the Add Page Panel.
   */
  InstallationOriginType["ADD_PAGE_PANEL"] = "ADD_PAGE_PANEL";
  /**
   * Application was copy-pasted by the user.
   */
  InstallationOriginType["COPY_PASTE"] = "COPY_PASTE";
  /**
   * Application was installed from the Funnel service.
   */
  InstallationOriginType["INTRO_FUNNEL"] = "INTRO_FUNNEL";
  /**
   * Application was installed from the Pages panel.
   */
  InstallationOriginType["PAGES_PANEL"] = "PAGES_PANEL";
  /**
   * Application was installed from Pages panel settings.
   */
  InstallationOriginType["PAGE_SETTINGS_PANEL"] = "PAGE_SETTINGS_PANEL";
  /**
   * Application was installed from Velo import panel.
   */
  InstallationOriginType["IMPORT_PANEL"] = "IMPORT_PANEL";
  /**
   * Application was installed from editor My Business Panel.
   */
  InstallationOriginType["MY_BUSINESS"] = "MY_BUSINESS";
  /**
   * Application was installed from JS-SDK iframe sdk.
   */
  InstallationOriginType["IFRAME_JS_SDK"] = "IFRAME_JS_SDK";
  /**
   * Application was installed from update modal
   */
  InstallationOriginType["UPDATE_PANEL"] = "UPDATE_PANEL";
})(InstallationOriginType || (InstallationOriginType = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/pageDefinition.js":
/*!***************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/pageDefinition.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/panels.js":
/*!*******************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/panels.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PagesPanelTabType: () => (/* binding */ PagesPanelTabType),
/* harmony export */   PanelResolveType: () => (/* binding */ PanelResolveType),
/* harmony export */   PanelType: () => (/* binding */ PanelType),
/* harmony export */   customizeActions: () => (/* binding */ customizeActions)
/* harmony export */ });
/**
 * @doc Editor
 */
var PanelType;
(function (PanelType) {
  PanelType["Settings"] = "settings";
  PanelType["Layout"] = "layout";
  PanelType["Design"] = "design";
  PanelType["Upgrade"] = "upgrade";
  PanelType["Add"] = "add";
})(PanelType || (PanelType = {}));
/**
 * @doc Editor
 */
var PanelResolveType;
(function (PanelResolveType) {
  PanelResolveType["MAIN_ACTION"] = "mainActionClicked";
  PanelResolveType["SECONDARY_ACTION"] = "secActionClicked";
  PanelResolveType["CLOSE_ACTION"] = "closeActionClicked";
})(PanelResolveType || (PanelResolveType = {}));
/**
 * @doc Editor
 */
var PagesPanelTabType;
(function (PagesPanelTabType) {
  PagesPanelTabType["PageInfo"] = "page_info";
  PagesPanelTabType["Layout"] = "layout";
  PagesPanelTabType["Permissions"] = "permissions";
  PagesPanelTabType["SEO"] = "seo";
})(PagesPanelTabType || (PagesPanelTabType = {}));
var customizeActions;
(function (customizeActions) {
  customizeActions["Custom"] = "Custom";
})(customizeActions || (customizeActions = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/premiumIntent.js":
/*!**************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/premiumIntent.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PremiumIntent: () => (/* binding */ PremiumIntent)
/* harmony export */ });
/**
 * @doc Editor
 */
var PremiumIntent;
(function (PremiumIntent) {
  PremiumIntent["Neutral"] = "NEUTRAL";
  PremiumIntent["Free"] = "FREE";
  PremiumIntent["Paid"] = "PAID";
})(PremiumIntent || (PremiumIntent = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/definitions/responsiveLayout.js":
/*!*****************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/definitions/responsiveLayout.js ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/editor-app.js":
/*!***********************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/editor-app.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/events/EventType.js":
/*!*****************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/events/EventType.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EventType: () => (/* binding */ EventType),
/* harmony export */   customEventTypes: () => (/* binding */ customEventTypes),
/* harmony export */   generalEventTypes: () => (/* binding */ generalEventTypes)
/* harmony export */ });
// If you're adding a custom event, add it also to customEventTypes in this file.
var EventType;
(function (EventType) {
  /**
   * An app's menu was reordered
   *
   * @type {string}
   */
  EventType["appMenuReorder"] = "appMenuReorder";
  /**
   * An app component was deleted.
   *
   * @type {string}
   */
  EventType["componentDeleted"] = "componentDeleted";
  /**
   * A connected component's GFPP was clicked
   *
   * @type {string}
   */
  EventType["componentGfppClicked"] = "componentGfppClicked";
  /**
   * An app action was clicked
   *
   * @type {string}
   */
  EventType["appActionClicked"] = "appActionClicked";
  /**
   * A connected component was pasted.
   *
   * @type {string}
   */
  EventType["connectedComponentPasted"] = "connectedComponentPasted";
  /**
   * A connected component was duplicated.
   *
   * @type {string}
   */
  EventType["connectedComponentDuplicated"] = "connectedComponentDuplicated";
  /**
   * A change was done to the app when a settings panel of the app is open by another user
   *
   * @type {string}
   */
  EventType["concurrentPanelEdit"] = "concurrentPanelEdit";
  /**
   * A widget was pasted.
   *
   * @type {string}
   */
  EventType["widgetPasted"] = "widgetPasted";
  /**
   * A widget was duplicated.
   *
   * @type {string}
   */
  EventType["widgetDuplicated"] = "widgetDuplicated";
  /**
   * A widget was added from any flow (add, duplicate, paste).
   *
   * @type {string}
   */
  EventType["widgetAdded"] = "widgetAdded";
  /**
   * A new controller was added to the stage for this app
   *
   * @type {string}
   */
  EventType["controllerAdded"] = "controllerAdded";
  /**
   * The controller's "settings" button was clicked
   *
   * @type {string}
   */
  EventType["controllerSettingsButtonClicked"] = "controllerSettingsButtonClicked";
  /**
   * The controller's gfpp button was clicked
   *
   * @type {string}
   */
  EventType["controllerGfppClicked"] = "controllerGfppClicked";
  /**
   * A StateBox's selected state has been changed
   *
   * @type {string}
   */
  EventType["stateChanged"] = "stateChanged";
  /**
   * A StateBox's state has been added
   *
   * @type {string}
   */
  EventType["stateAdded"] = "stateAdded";
  /**
   * A StateBox's state has been duplicated
   *
   * @type {string}
   */
  EventType["stateDuplicated"] = "stateDuplicated";
  /**
   * An app's page was deleted
   *
   * @type {string}
   */
  EventType["pageDeleted"] = "pageDeleted";
  /**
   * The site was published
   *
   * @type {string}
   */
  EventType["siteWasPublished"] = "siteWasPublished";
  /**
   * The site was saved for the first time.
   *
   * @type {string}
   */
  EventType["siteWasFirstSaved"] = "siteWasFirstSaved";
  /**
   * The site was saved, first time or any time.
   *
   * @type {string}
   */
  EventType["siteWasSaved"] = "siteWasSaved";
  /**
   * The panel was loaded with the specified configuration
   *
   * @type {string}
   */
  EventType["startConfiguration"] = "startConfiguration";
  /**
   * The apps' welcome section's main action was clicked in the add panel
   *
   * @type {string}
   */
  EventType["welcomeSectionMainActionClicked"] = "welcomeSectionMainActionClicked";
  /**
   * A widget's gfpp button was clicked
   *
   * @type {string}
   */
  EventType["widgetGfppClicked"] = "widgetGfppClicked";
  /**
   * An app was upgraded successfully
   *
   * @type {string}
   */
  EventType["appUpgradeCompleted"] = "appUpgradeCompleted";
  /**
   * An app instance was changed
   *
   * @type {string}
   */
  EventType["instanceChanged"] = "instanceChanged";
  /**
   * Components selection was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentSelectionChanged"] = "componentSelectionChanged";
  /**
   * A preset in the global design was clicked
   *
   * @type {string}
   */
  EventType["globalDesignPresetChanged"] = "globalDesignPresetChanged";
  /**
   * Developer mode was turned on or off
   *
   * @type {string}
   */
  EventType["developerModeChanged"] = "developerModeChanged";
  /**
   * Developer mode status was changed
   *
   * @type {string}
   */
  EventType["developerModeStatusChanged"] = "developerModeStatusChanged";
  /**
   * Focused page has changed. Called after navigation to page or lightbox
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["focusedPageChanged"] = "focusedPageChanged";
  /**
   * Component Added to editor stage
   *
   * @deprecated — listen to `connectedComponentAddedToStage` for notifications about
   * TPA's connected components or to `anyComponentAddedToStage` for notifications about any component
   * @type {string}
   */
  EventType["componentAddedToStage"] = "componentAddedToStage";
  /**
   * A component connected to your TPA was added to the Editor stage.
   *
   * @type {string}
   */
  EventType["connectedComponentAddedToStage"] = "connectedComponentAddedToStage";
  /**
   * A widget's preset was changed.
   *
   * @type {string}
   */
  EventType["presetChanged"] = "presetChanged";
  /**
   * Any component was added to the Editor stage
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["anyComponentAddedToStage"] = "anyComponentAddedToStage";
  /**
   * Application version was updated
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["appUpdateCompleted"] = "appUpdateCompleted";
  /**
   * The app's live preview was refreshed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["appRefreshCompleted"] = "appRefreshCompleted";
  /**
   * Component animation was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentAnimationChanged"] = "componentAnimationChanged";
  /**
   * Component data was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentDataChanged"] = "componentDataChanged";
  /**
   * Component design was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentDesignChanged"] = "componentDesignChanged";
  /**
   * Component design was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentStyleChanged"] = "componentStyleChanged";
  /**
   * Editor switched back from preview
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["switchedFromPreview"] = "switchedFromPreview";
  /**
   * Component arrangement was changed (z-index)
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentArrangementChanged"] = "componentArrangementChanged";
  /**
   * Component drag ended
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentDragEnded"] = "componentDragEnded";
  /**
   * Component resize started
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentResizeStarted"] = "componentResizeStarted";
  /**
   * Component rotate ended
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentRotateEnded"] = "componentRotateEnded";
  /**
   * Site published success dialog was closed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["sitePublishedDialogClosed"] = "sitePublishedDialogClosed";
  /**
   * page background was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["pageBackgroundChanged"] = "pageBackgroundChanged";
  /**
   * Component text scale was changed in mobile
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["mobileTextScaleChanged"] = "mobileTextScaleChanged";
  /**
   * Component crop was saved
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentCropSaved"] = "componentCropSaved";
  /**
   * Mobile back-to-top button was toggled on
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["toggleBackToTopButtonOn"] = "toggleBackToTopButtonOn";
  /**
   * Component behavior was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentBehaviorChanged"] = "componentBehaviorChanged";
  /**
   * Component properties data was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["componentPropsChanged"] = "componentPropsChanged";
  /**
   * Switched to mobile editor (relevant only for Wix Editor)
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["switchedToMobileView"] = "switchedToMobileView";
  /**
   * Switched to desktop editor (relevant only for Wix Editor)
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["switchedToDesktopView"] = "switchedToDesktopView";
  /**
   * Text settings panel was closed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["textEditBoxClosed"] = "textEditBoxClosed";
  /**
   * Hide element from mobile
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["hideMobileElement"] = "hideMobileElement";
  /**
   * Show hidden element in mobile
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["showMobileElement"] = "showMobileElement";
  /**
   * Page has been renamed
   * Applications that manage their pages directly, or with a router, will both be notified of this event.
   *
   * @type {string}
   */
  EventType["pageRenamed"] = "pageRenamed";
  /**
   * User clicked button on popup that recommends using dynamic pages.
   * Use this event to notify the data-binding application to begin the dynamic pages workflow.
   *
   * @type {string}
   */
  EventType["addDynamicPageClicked"] = "addDynamicPageClicked";
  /**
   * The consent policy was changed.
   *
   * @type {string}
   */
  EventType["consentPolicyChanged"] = "consentPolicyChanged";
  /**
   * A page or lightbox was duplicated.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
   *
   * @type {string}
   */
  EventType["pageDuplicated"] = "pageDuplicated";
  /**
   * A page or lightbox was added.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
   *
   * @type {string}
   */
  EventType["pageAdded"] = "pageAdded";
  /**
   * A user performed an undo action. This event is non-specific. For example, if a user deletes a component, a [componentDeleted](#componentDeleted) event is triggered. If the user performs an undo, you receive the *undo* event, not a component added event.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
   *
   * @type {string}
   */
  EventType["undo"] = "undo";
  /**
   * A user performed a redo action. This event is non-specific. For example, if a user deletes a component, a [componentDeleted](#componentDeleted) event is triggered. If the user performs an undo and then a redo, you receive the *undo* and *redo* events, not events related to the addition and deletion of the component.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
   *
   * @type {string}
   */
  EventType["redo"] = "redo";
  /**
   * Add Elements panel - Add Component clicked
   *
   * @type {string}
   */
  EventType["addElementsCompClicked"] = "addElementsCompClicked";
  /**
   * Add Elements panel - Add All Components button clicked
   *
   * @type {string}
   */
  EventType["addElementsAllCompsClicked"] = "addElementsAllCompsClicked";
  /**
   * Add Elements panel - Snap To Latest Version button clicked
   *
   * @type {string}
   */
  EventType["addElementsResetClicked"] = "addElementsResetClicked";
  /**
   * User visited the app listing in the dashboard panel. This event is triggered after the dashboard is closed in order to let the applications refresh the visited apps.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["appVisitedInDashboard"] = "appVisitedInDashboard";
  /**
   * Component was added to the app's container (AppWidget)
   *
   * @type {string}
   */
  EventType["componentAddedToApp"] = "componentAddedToApp";
  /**
   * An error occurred during a document services operation.
   *
   * @type {string}
   */
  EventType["documentOperationError"] = "documentOperationError";
  /**
   * An event for handling limitation when trying to add widget.
   *
   * @type {string}
   */
  EventType["solveAddWidgetLimitation"] = "solveAddWidgetLimitation";
  /**
   * A component was connected to a controller.
   *
   * @type {string}
   */
  EventType["componentConnected"] = "componentConnected";
  /**
   * A component was disconnected from a controller.
   *
   * @type {string}
   */
  EventType["componentDisconnected"] = "componentDisconnected";
  /**
   * A panel header button was clicked.
   *
   * @type {string}
   */
  EventType["panelHeaderButtonClicked"] = "panelHeaderButtonClicked";
  /**
   * Site theme was changed.
   *
   * @type {string}
   */
  EventType["themeChanged"] = "themeChanged";
  /**
   * View state of a widget was changed.
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["viewStateChanged"] = "viewStateChanged";
  /**
   * The app's permissions were revoked following an undo/redo process.
   * @type {string}
   */
  EventType["revokeApp"] = "revokeApp";
  /**
   * The app's permissions were granted following an undo/redo process.
   * @type {string}
   */
  EventType["grantApp"] = "grantApp";
  /**
   * An app's page variant was selected
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
   *
   * @type {string}
   */
  EventType["pageVariantSelected"] = "pageVariantSelected";
  /**
   * A widget's overrides were reset
   *
   * @type {string}
   */
  EventType["resetWidgetOverrides"] = "resetWidgetOverrides";
  /**
   * Widget plugin was added
   *
   * @type {string}
   */
  EventType["widgetPluginAdded"] = "widgetPluginAdded";
  /**
   * Widget plugin was removed
   * @type {string}
   */
  EventType["widgetPluginRemoved"] = "widgetPluginRemoved";
  /**
   * Widget plugin was shown on page
   *
   * @type {string}
   */
  EventType["widgetPluginShowOnPageClicked"] = "widgetPluginShowOnPageClicked";
  /**
   * @internal
   * The app was installed
   * @type {string}
   */
  EventType["appInstalled"] = "appInstalled";
  /**
   * @internal
   * The app was removed
   * @type {string}
   */
  EventType["removeAppCompleted"] = "removeAppCompleted";
  /**
   * Site language was changed
   * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
   *
   * @type {string}
   */
  EventType["siteLanguageChanged"] = "siteLanguageChanged";
})(EventType || (EventType = {}));
/**
 * @hidden
 * The lists below help you differentiate between custom & general events for the SDK testkit.
 * As of now there is no proper way to split the enum of events into 2 separate enums and keep the usage the same as before.
 * EventInterfaces uses enum’s values in dot notation so converting enum into js object (const EventType = {...CustomEventType, ...GeneralEventType})
 * would not work in the same way (EventType.someEvent -> EventType[‘someEvent’] to access type of the property), which would be a breaking change.
 */
/**
 * Custom events list
 */
const customEventTypes = [EventType.componentSelectionChanged, EventType.focusedPageChanged, EventType.anyComponentAddedToStage, EventType.appUpdateCompleted, EventType.componentAnimationChanged, EventType.componentDataChanged, EventType.componentDesignChanged, EventType.componentStyleChanged, EventType.switchedFromPreview, EventType.componentArrangementChanged, EventType.componentDragEnded, EventType.componentResizeStarted, EventType.componentRotateEnded, EventType.sitePublishedDialogClosed, EventType.pageBackgroundChanged, EventType.mobileTextScaleChanged, EventType.componentCropSaved, EventType.toggleBackToTopButtonOn, EventType.componentBehaviorChanged, EventType.appRefreshCompleted, EventType.componentPropsChanged, EventType.switchedToMobileView, EventType.switchedToDesktopView, EventType.textEditBoxClosed, EventType.hideMobileElement, EventType.showMobileElement, EventType.undo, EventType.redo, EventType.appVisitedInDashboard, EventType.developerModeStatusChanged, EventType.componentConnected, EventType.componentDisconnected, EventType.solveAddWidgetLimitation, EventType.pageDuplicated, EventType.pageAdded, EventType.themeChanged, EventType.viewStateChanged, EventType.pageVariantSelected, EventType.siteLanguageChanged];
/**
 * General events list
 */
const generalEventTypes = [EventType.appMenuReorder, EventType.componentDeleted, EventType.componentGfppClicked, EventType.appActionClicked, EventType.connectedComponentPasted, EventType.connectedComponentDuplicated, EventType.concurrentPanelEdit, EventType.widgetPasted, EventType.widgetDuplicated, EventType.widgetAdded, EventType.resetWidgetOverrides, EventType.widgetPluginAdded, EventType.widgetPluginRemoved, EventType.widgetPluginShowOnPageClicked, EventType.controllerAdded, EventType.controllerSettingsButtonClicked, EventType.controllerGfppClicked, EventType.presetChanged, EventType.stateChanged, EventType.stateAdded, EventType.stateDuplicated, EventType.pageDeleted, EventType.siteWasPublished, EventType.siteWasFirstSaved, EventType.siteWasSaved, EventType.startConfiguration, EventType.welcomeSectionMainActionClicked, EventType.widgetGfppClicked, EventType.appUpgradeCompleted, EventType.instanceChanged, EventType.globalDesignPresetChanged, EventType.developerModeChanged, EventType.connectedComponentAddedToStage, EventType.pageRenamed, EventType.addDynamicPageClicked, EventType.consentPolicyChanged, EventType.addElementsCompClicked, EventType.addElementsAllCompsClicked, EventType.addElementsResetClicked, EventType.componentAddedToApp, EventType.documentOperationError, EventType.panelHeaderButtonClicked, EventType.grantApp, EventType.revokeApp, EventType.appInstalled, EventType.removeAppCompleted];

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/events/EventsInterfaceMap.js":
/*!**************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/events/EventsInterfaceMap.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/events/eventInterfaces.js":
/*!***********************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/events/eventInterfaces.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/events/index.js":
/*!*************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/events/index.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EventType: () => (/* reexport safe */ _EventType__WEBPACK_IMPORTED_MODULE_1__.EventType),
/* harmony export */   customEventTypes: () => (/* reexport safe */ _EventType__WEBPACK_IMPORTED_MODULE_1__.customEventTypes),
/* harmony export */   generalEventTypes: () => (/* reexport safe */ _EventType__WEBPACK_IMPORTED_MODULE_1__.generalEventTypes)
/* harmony export */ });
/* harmony import */ var _eventInterfaces__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./eventInterfaces */ "../editor-platform-sdk-types/dist/esm/events/eventInterfaces.js");
/* harmony import */ var _EventType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EventType */ "../editor-platform-sdk-types/dist/esm/events/EventType.js");
/* harmony import */ var _EventsInterfaceMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EventsInterfaceMap */ "../editor-platform-sdk-types/dist/esm/events/EventsInterfaceMap.js");




/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/index.js":
/*!******************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AddElementsPanelBannerIcons: () => (/* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_2__.AddElementsPanelBannerIcons),
/* harmony export */   DeviceType: () => (/* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_2__.DeviceType),
/* harmony export */   EditorSubType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.EditorSubType),
/* harmony export */   EditorType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.EditorType),
/* harmony export */   EventType: () => (/* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_4__.EventType),
/* harmony export */   InstallInitiator: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.InstallInitiator),
/* harmony export */   InstallationOriginType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.InstallationOriginType),
/* harmony export */   LinkTypes: () => (/* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_2__.LinkTypes),
/* harmony export */   MediaType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.MediaType),
/* harmony export */   MemberKind: () => (/* reexport safe */ _manifest__WEBPACK_IMPORTED_MODULE_1__.MemberKind),
/* harmony export */   NotificationPresetTypes: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.NotificationPresetTypes),
/* harmony export */   NotificationType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.NotificationType),
/* harmony export */   PagesPanelTabType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.PagesPanelTabType),
/* harmony export */   PanelResolveType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.PanelResolveType),
/* harmony export */   PanelType: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.PanelType),
/* harmony export */   PremiumIntent: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.PremiumIntent),
/* harmony export */   TPAComponentType: () => (/* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_2__.TPAComponentType),
/* harmony export */   WidgetInstallationType: () => (/* reexport safe */ _common__WEBPACK_IMPORTED_MODULE_2__.WidgetInstallationType),
/* harmony export */   customEventTypes: () => (/* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_4__.customEventTypes),
/* harmony export */   customizeActions: () => (/* reexport safe */ _definitions__WEBPACK_IMPORTED_MODULE_3__.customizeActions),
/* harmony export */   generalEventTypes: () => (/* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_4__.generalEventTypes)
/* harmony export */ });
/* harmony import */ var _editor_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./editor-app */ "../editor-platform-sdk-types/dist/esm/editor-app.js");
/* harmony import */ var _manifest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./manifest */ "../editor-platform-sdk-types/dist/esm/manifest.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "../editor-platform-sdk-types/dist/esm/common.js");
/* harmony import */ var _definitions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./definitions */ "../editor-platform-sdk-types/dist/esm/definitions/index.js");
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./events */ "../editor-platform-sdk-types/dist/esm/events/index.js");
/* harmony import */ var _tpaStyleParams__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./tpaStyleParams */ "../editor-platform-sdk-types/dist/esm/tpaStyleParams.js");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./sdk */ "../editor-platform-sdk-types/dist/esm/sdk/index.js");








/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/manifest.js":
/*!*********************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/manifest.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MemberKind: () => (/* binding */ MemberKind)
/* harmony export */ });
var MemberKind;
(function (MemberKind) {
  MemberKind["MEMBER"] = "member";
  MemberKind["FUNCTION"] = "function";
})(MemberKind || (MemberKind = {}));

/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/app-settings.js":
/*!*****************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/app-settings.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/document/application.js":
/*!*************************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/document/application.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/document/index.js":
/*!*******************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/document/index.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _application__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./application */ "../editor-platform-sdk-types/dist/esm/sdk/document/application.js");


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/editor/index.js":
/*!*****************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/editor/index.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/editorSDK.js":
/*!**************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/editorSDK.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/event-listeners.js":
/*!********************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/event-listeners.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/extra.js":
/*!**********************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/extra.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/sdk/index.js":
/*!**********************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/sdk/index.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _editorSDK__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./editorSDK */ "../editor-platform-sdk-types/dist/esm/sdk/editorSDK.js");
/* harmony import */ var _extra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./extra */ "../editor-platform-sdk-types/dist/esm/sdk/extra.js");
/* harmony import */ var _event_listeners__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./event-listeners */ "../editor-platform-sdk-types/dist/esm/sdk/event-listeners.js");
/* harmony import */ var _editor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./editor */ "../editor-platform-sdk-types/dist/esm/sdk/editor/index.js");
/* harmony import */ var _app_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-settings */ "../editor-platform-sdk-types/dist/esm/sdk/app-settings.js");
/* harmony import */ var _document__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./document */ "../editor-platform-sdk-types/dist/esm/sdk/document/index.js");







/***/ }),

/***/ "../editor-platform-sdk-types/dist/esm/tpaStyleParams.js":
/*!***************************************************************!*\
  !*** ../editor-platform-sdk-types/dist/esm/tpaStyleParams.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!******************!*\
  !*** ./index.ts ***!
  \******************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AddElementsPanelBannerIcons: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.AddElementsPanelBannerIcons),
/* harmony export */   DeviceType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.DeviceType),
/* harmony export */   EditorSubType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.EditorSubType),
/* harmony export */   EditorType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.EditorType),
/* harmony export */   EventType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.EventType),
/* harmony export */   InstallInitiator: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.InstallInitiator),
/* harmony export */   InstallationOriginType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.InstallationOriginType),
/* harmony export */   LinkTypes: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.LinkTypes),
/* harmony export */   MediaType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.MediaType),
/* harmony export */   MemberKind: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.MemberKind),
/* harmony export */   NotificationPresetTypes: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.NotificationPresetTypes),
/* harmony export */   NotificationType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.NotificationType),
/* harmony export */   PagesPanelTabType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.PagesPanelTabType),
/* harmony export */   PanelResolveType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.PanelResolveType),
/* harmony export */   PanelType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.PanelType),
/* harmony export */   PremiumIntent: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.PremiumIntent),
/* harmony export */   TPAComponentType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.TPAComponentType),
/* harmony export */   WidgetInstallationType: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.WidgetInstallationType),
/* harmony export */   customEventTypes: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.customEventTypes),
/* harmony export */   customizeActions: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.customizeActions),
/* harmony export */   generalEventTypes: () => (/* reexport safe */ _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__.generalEventTypes)
/* harmony export */ });
/* harmony import */ var _wix_editor_platform_sdk_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @wix/editor-platform-sdk-types */ "../editor-platform-sdk-types/dist/esm/index.js");

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//esm-shim-webpack-plugin-exports
